import { compareTwoStrings } from 'string-similarity';

// This service simulates advanced matching algorithms.
const matchingService = {
    /**
     * Simulates fuzzy matching using the Sørensen-Dice coefficient.
     * @param {string} str1 - The first string (e.g., customer name).
     * @param {string} str2 - The second string (e.g., watchlist name).
     * @returns {number} A similarity score between 0 and 1.
     */
    fuzzyMatch: (str1, str2) => {
        if (!str1 || !str2) return 0;
        return compareTwoStrings(str1.toLowerCase(), str2.toLowerCase());
    },

    /**
     * A simple deterministic match for IDs or exact identifiers.
     * @param {string} val1
     * @param {string} val2
     * @returns {boolean}
     */
    deterministicMatch: (val1, val2) => {
        if (!val1 || !val2) return false;
        return val1.trim().toLowerCase() === val2.trim().toLowerCase();
    },
};

export default matchingService;